/* 
*  Created by SGiri 07/12/2018
*/

import { Injectable } from '@angular/core';
import { CognosConstants } from '~cognos/util/cognos.constant';
import { BI_HttpService } from '../../services/http.service';

@Injectable()
export class CognosService {

  constructor(private http: BI_HttpService) { }

  getSearchFolders(): any[] {
    return ['Public Folders', 'My Folders'];
  }

  public getCognosSearchData(searchReq: any) {
    return this.http.post(CognosConstants.SEARCH_URL, searchReq);
  }
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/cognos/service/cognos.service.ts